// extracted by mini-css-extract-plugin
export var ModalDialog = "ModalDialog-module--ModalDialog--3Iqx0";
export var ModalDialogIn = "ModalDialog-module--ModalDialogIn--QXMaE";
export var ModalDialogOut = "ModalDialog-module--ModalDialogOut--5ySu3";
export var ModalDialogWrapper = "ModalDialog-module--ModalDialogWrapper--SD+90";
export var modalDialogSlideIn = "ModalDialog-module--modal-dialog-slide-in--Ch3pl";
export var modalDialogSlideOut = "ModalDialog-module--modal-dialog-slide-out--kwCJ3";